// Types
import { RootState } from 'types/RootState.types';

// Config
import { isOneMan } from '@utils/delivery/deliveryHelper';
import { isFeatureActive } from '@redux/reducers/config/configReducer';
import featureConstants from '@constants/featureConstants';

export function shouldShowThresholdBar(state: RootState) {
  const {
    app: {
      isExpressCheckout = false,
    } = {},
    delivery: {
      deliveries = [],
      items = [],
    } = {},
  } = state ?? {};

  if (isFeatureActive(state, featureConstants.DISABLE_THRESHOLD_BAR)) return false;

  if (isExpressCheckout) {
    return false;
  };

  const hasOutlet = deliveries?.some((delivery) => delivery.outlet);
  if (hasOutlet) {
    return false;
  };

  const isShipFromStore = items?.some(item => item.availability?.shipFromStore);
  if (isShipFromStore) {
    return false;
  };


  const isSingleBatchOneMan = deliveries.length === 1 && isOneMan(deliveries[0].type);

  return isSingleBatchOneMan;
};
